<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Edit Photo</h4>
</div>
<div class="modal-body row">
  <div class="col-md-8">
    <div class="cropper-container" [class.no-image]="!imageData">
      <app-photo-cropper
        [imageData]="imageData"
        (onImageCrop)="imageCropped($event)"
      ></app-photo-cropper>
      <span class="no-image-label">Please select a photo</span>
    </div>
    <div class="actions my-2">
      <button class="btn btn-success me-2" (click)="selectPhoto()">
        {{ imageData ? "Change Photo" : "Select Photo" }}
      </button>
      <button class="btn btn-danger" (click)="clearPhoto()">
        <i class="uil-trash-alt"></i>
      </button>
    </div>
  </div>
  <div class="col-md-4">
    <div class="mb-2">Preview</div>
    <img class="cropped-image" [src]="croppedImage" *ngIf="croppedImage" />
    <span *ngIf="!croppedImage">No preview yet</span>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success my-2" (click)="savePhoto()">Save</button>
  <button type="button" class="btn btn-light my-2" (click)="closeModal()">Cancel</button>
</div>
